exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.info .ant-row.ant-form-item {\n  width: 100%;\n  margin-right: 6px;\n}\n.ant-modal-footer button.ant-btn {\n  width: 75px !important;\n}\n.ant-form-explain {\n  font-size: 12px;\n  color: red;\n}\n", ""]);

// exports
